import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Box, Card, CardContent, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField, Typography, InputAdornment, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Seo from '../Seo/Seo';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const styles = theme => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'radial-gradient(circle at top, #1c2c2f 0%, #0f1116 45%, #0a0c10 100%)',
    padding: theme.spacing(4),
  },
  card: {
    textAlign: 'left',
    background: 'rgba(20, 24, 28, 0.86)',
    color: '#f5f7fa',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 24,
    border: '1px solid rgba(255,255,255,0.08)',
    boxShadow: '0 24px 70px rgba(0,0,0,0.45)',
    backdropFilter: 'blur(16px)',
  },
  cardContent: {
    padding: theme.spacing(4),
  },
  header: {
    color: '#72f7c4',
    fontWeight: 700,
  },
  subheader: {
    color: 'rgba(245, 247, 250, 0.7)',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  form: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  field: {
    width: '100%',
    '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: 'rgba(120, 255, 200, 0.7)',
    },
  },
  input: {
    color: '#f5f7fa',
  },
  cssLabel: {
    color: 'rgba(245, 247, 250, 0.7)',
    '&$cssFocused': {
      color: '#72f7c4',
    },
  },
  cssOutlinedInput: {
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    borderRadius: 14,
    '&$cssFocused $notchedOutline': {
      borderColor: '#72f7c4',
      borderWidth: 2,
    },
  },
  cssFocused: {},
  notchedOutline: { borderColor: 'rgba(255,255,255,0.16)' },
  radioGroup: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  radioLabel: {
    color: 'rgba(245, 247, 250, 0.8)',
    '& .MuiSvgIcon-root': {
      color: '#72f7c4',
    },
  },
  helperText: {
    color: 'rgba(245, 247, 250, 0.7)',
    fontSize: '0.9rem',
  },
  icon: {
    color: '#d0fced',
  },
  button: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.4, 0),
    fontWeight: 600,
    borderRadius: 14,
    background: 'linear-gradient(135deg, #72f7c4 0%, #4ad6ff 100%)',
    color: '#0a0c10',
    textTransform: 'none',
    boxShadow: '0 10px 30px rgba(74, 214, 255, 0.35)',
    '&:hover': {
      background: 'linear-gradient(135deg, #8bffd2 0%, #6fe0ff 100%)',
    },
  },
});
class RegisterPage extends Component {

  state = {
    firstName: '',
    lastName: '',
    username: '',
    password: '',
    confirmPassword: '',
    clearanceId: '',
    teamName: '',
    accessId: '',
    showPassword: false,
    showConfirmPassword: false,
    error: '',
  };

  registerTeam() {

    if (this.state.clearanceId === '2') {

      this.generateAccessId();

      this.props.dispatch({
        type: 'TEAM_REGISTER',
        payload: {
          teamName: this.state.teamName,
          username: this.state.username,
          password: this.state.password,
          confirmPassword: this.state.confirmPassword,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          clearanceId: this.state.clearanceId,
          accessId: this.state.accessId,
        }
      })
    } else if (this.state.clearanceId === '1') {
      this.props.dispatch({
        type: 'USER_REGISTER',
        payload: {
          username: this.state.username,
          password: this.state.password,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          clearanceId: this.state.clearanceId,
          accessId: this.state.accessId,
        }
      })
    }
    this.props.history.push(`/main`);
  } // end register

  handleInputChangeFor = propertyName => (event) => {
    this.setState({
      [propertyName]: event.target.value,
    });
    console.log('changing the first name:', this.state.firstName)
  }

  generateAccessId() {
    this.state.accessId = Math.floor(Math.random() * 90000000) + 10000000;
  }

  passwordValidation() {
    const { password, confirmPassword } = this.state;

    if (password.length < 8 || !/[A-Z]/.test(password) || !/[^A-Za-z0-9]/.test(password)) {
      this.setState({ error: 'Password must be at least 8 characters and include at least one uppercase letter and one special character.' });
      return false;
    }

    if (password !== confirmPassword) {
      this.setState({ error: 'Passwords do not match.' });
      return false;
    }

    this.setState({ error: '' });
    this.registerTeam();
    return true;
  }

  fieldValidation = event => {
    event.preventDefault();
    this.setState({ error: '' });

    if (!this.state.firstName) {
      alert("Please enter a value for First Name.");
      return false;
    }
    if (!this.state.lastName) {
      alert("Please enter a value for Last Name.");
      return false;
    }
    if (!this.state.username) {
      alert("Please enter a value for Email Address.");
      return false;
    }
    if (!this.state.password) {
      alert("Please enter a value for Password.");
      return false;
    }
    if (!this.state.confirmPassword) {
      alert("Please enter a value for Confirm Password.");
      return false;
    }
    if (this.state.clearanceId === '') {
      alert("Please select whether you are creating a new team or joining an existing team.");
      return false;
    }
    if (this.state.clearanceId === '2' && !this.state.teamName) {
      alert("Please enter a Team Name.");
      return false;
    }
    if (this.state.clearanceId === '1' && !this.state.accessId) {
      alert("Please enter your team's private Access Code.");
      return false;
    }

    this.passwordValidation();
    
  }

  render() {

    const { classes } = this.props;

    return (
      <Box className={classes.root}>
        <Seo
          title="Create Your Trivia Team | Trivia Weekend"
          description="Register your Trivia Weekend team to organize marathon trivia schedules, invite players, and track live answers."
          canonicalPath="/#/register"
          ogType="website"
        />
        <Grid container justify="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <Card className={classes.card}>
              <CardContent className={classes.cardContent}>
                {this.props.errors.registrationMessage && (
                  <h2
                    className="alert"
                    role="alert"
                  >
                    {this.props.errors.registrationMessage}
                  </h2>
                )}

                <form onSubmit={this.fieldValidation} className={classes.form}>
                  <div>
                    <Typography variant="h4" component="h1" className={classes.header}>
                      Register
                    </Typography>
                    <Typography variant="subtitle1" className={classes.subheader}>
                      Build your trivia profile and pick how you want to play.
                    </Typography>
                  </div>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        align="left"
                        id="outlined-first-name"
                        label="First Name"
                        className={classes.field}
                        value={this.state.firstName}
                        onChange={this.handleInputChangeFor("firstName")}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                          className: classes.input,
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline
                          }
                        }}
                        InputLabelProps={{
                          className: classes.cssLabel,
                          shrink: true
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        align="left"
                        id="outlined-last-name"
                        label="Last Name"
                        className={classes.field}
                        value={this.state.lastName}
                        onChange={this.handleInputChangeFor("lastName")}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                          className: classes.input,
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline
                          }
                        }}
                        InputLabelProps={{
                          className: classes.cssLabel,
                          shrink: true
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        align="left"
                        id="outlined-email"
                        label="Email Address"
                        className={classes.field}
                        value={this.state.username}
                        onChange={this.handleInputChangeFor("username")}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                          className: classes.input,
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline
                          }
                        }}
                        InputLabelProps={{
                          className: classes.cssLabel,
                          shrink: true
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        type={this.state.showPassword ? 'text' : 'password'}
                        align="left"
                        id="outlined-password"
                        label="Password"
                        className={classes.field}
                        value={this.state.password}
                        onChange={this.handleInputChangeFor("password")}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                          className: classes.input,
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline
                          },
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                className={classes.icon}
                                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                edge="end"
                              >
                                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        InputLabelProps={{
                          className: classes.cssLabel,
                          shrink: true
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        type={this.state.showConfirmPassword ? 'text' : 'password'}
                        align="left"
                        id="outlined-confirm-password"
                        label="Confirm Password"
                        className={classes.field}
                        value={this.state.confirmPassword}
                        onChange={this.handleInputChangeFor("confirmPassword")}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                          className: classes.input,
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline
                          },
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                className={classes.icon}
                                onClick={() => this.setState({ showConfirmPassword: !this.state.showConfirmPassword })}
                                edge="end"
                              >
                                {this.state.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        InputLabelProps={{
                          className: classes.cssLabel,
                          shrink: true
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Typography className={classes.helperText}>
                    Password must be at least 8 characters and include at least one uppercase letter and one special character.
                  </Typography>

                  {this.state.error && (
                    <Typography className="alert" role="alert">
                      {this.state.error}
                    </Typography>
                  )}

                  <FormControl component="fieldset" className={classes.radioGroup}>
                    <FormLabel component="legend" className={classes.helperText}>
                      Choose your team setup
                    </FormLabel>
                    <RadioGroup
                      aria-label="newTeam"
                      name="newTeam"
                      onChange={this.handleInputChangeFor("clearanceId")}
                    >
                      <FormControlLabel
                        className={classes.radioLabel}
                        value="2"
                        control={<Radio />}
                        label="Create a new team"
                      />
                      <FormControlLabel
                        className={classes.radioLabel}
                        value="1"
                        control={<Radio />}
                        label="Join an existing team"
                      />
                    </RadioGroup>
                  </FormControl>

                  {this.state.clearanceId == 1 && (
                    <Typography className={classes.helperText}>
                      Enter your team's private access code.
                    </Typography>
                  )}
                  {this.state.clearanceId == 2 && (
                    <Typography className={classes.helperText}>
                      Name your new team to get started.
                    </Typography>
                  )}

                  <Grid container spacing={2}>
                    {this.state.clearanceId == 2 && (
                      <Grid item xs={12}>
                        <TextField
                          align="left"
                          id="outlined-team-name"
                          label="Team Name"
                          className={classes.field}
                          value={this.state.teamName}
                          onChange={this.handleInputChangeFor("teamName")}
                          margin="normal"
                          variant="outlined"
                          InputProps={{
                            className: classes.input,
                            classes: {
                              root: classes.cssOutlinedInput,
                              focused: classes.cssFocused,
                              notchedOutline: classes.notchedOutline
                            }
                          }}
                          InputLabelProps={{
                            className: classes.cssLabel,
                            shrink: true
                          }}
                        />
                      </Grid>
                    )}
                    {this.state.clearanceId == 1 && (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          align="left"
                          id="outlined-access-code"
                          label="Team Access Code"
                          className={classes.field}
                          value={this.state.accessId}
                          onChange={this.handleInputChangeFor("accessId")}
                          margin="normal"
                          variant="outlined"
                          InputProps={{
                            className: classes.input,
                            classes: {
                              root: classes.cssOutlinedInput,
                              focused: classes.cssFocused,
                              notchedOutline: classes.notchedOutline
                            }
                          }}
                          InputLabelProps={{
                            className: classes.cssLabel,
                            shrink: true
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>

                  <Button
                    className={classes.button}
                    type="submit"
                    name="submit"
                    value="Register"
                  >
                    Register
                  </Button>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  }
}


// Instead of taking everything from state, we just want the error messages.
// if you wanted you could write this code like this:
// const mapStateToProps = ({errors}) => ({ errors });
const mapStateToProps = state => ({
  errors: state.errors,
  user: state.user,
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(RegisterPage)));
